import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ApplicationStatus } from '../../../graphql/graphql-operations';
import { SectionPaper } from '../../components/SectionPaper';
import { TopBar } from '../../components/TopBar';
import ApplicationsTable from './ApplicationsTable';

const ApplicationsSuspendedPage: React.VFC = () => {
  const { t } = useTranslation();

  return (
    <>
      <TopBar
        leftSideText={t(
          'applications.topBar.suspendedTitle',
          'Archived applications',
        )}
        actions={
          <Button
            id="applications-suspended-page-active"
            size="large"
            color="primary"
            variant="text"
            component={Link}
            to={'/admin/applications'}
          >
            {t(`applications.activeApplications`, 'Active Applications')}
          </Button>
        }
      />
      <SectionPaper>
        <ApplicationsTable status={ApplicationStatus.SUSPENDED} />
      </SectionPaper>
    </>
  );
};

export default ApplicationsSuspendedPage;
